import _extends from '@babel/runtime/helpers/extends';
import React__default, { memo } from 'react';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-Bjtexw5f.js';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { m as externalLinkAlt } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { I as Icon } from '../../Icon/Icon-DowU4ANk.js';

const NodeSafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;

/*
* When using alternative background colors, links must have additional selector specificity
* to override AUI rules. Existing applications depend on legacy link specificity, so it
* must only be applied to links within <SurfaceXxxx> containers
*/
function overrideAuiLinkStyle({
  theme
}) {
  var _theme$link;
  if ((theme === null || theme === void 0 || (_theme$link = theme.link) === null || _theme$link === void 0 ? void 0 : _theme$link.overrideAuiLinkStyle) === true) {
    return `a:is(&&), a:is(&&):visited, a:is(&&):active, a:is(&&):link {${theme.typography.a}}`;
  }
  return '';
}
const StyledLink = /*#__PURE__*/styled('a').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    $focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30054544__sc-1bv5f00-0"
})(["", ";font-size:", ";", " :focus{", "}", ""], ({
  theme
}) => theme.typography.a, ({
  $size,
  theme
}) => theme.link[$size] || 'inherit', isMobile(css(["font-size:", ";"], ({
  $size,
  theme
}) => theme.mobile.link[$size] || 'inherit')), ({
  $focusVisible
}) => $focusVisible && focusOutline, overrideAuiLinkStyle);
StyledLink.displayName = 'StyledLink';
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30054544__sc-1bv5f00-1"
})(["font-size:0.85em;"]);
/**
 * Link
 */
const Link = ({
  children,
  href,
  external = false,
  size = 'inherit',
  anchorRef,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('link')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledLink, _extends({}, getDataTaktAttributes(), rest, {
  $size: size,
  href: href,
  ref: anchorRef
}), children, external && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\xA0", /*#__PURE__*/React__default.createElement(StyledIcon, {
  type: externalLinkAlt
}))));
Link.propTypes = {
  /**
    * The text of the link. This can also be a react node when special formatting is required.
    */
  children: PT.node.isRequired,
  /**
    * The Link URL. If you don't have an href, you should probably be using a TextButton instead
    */
  href: PT.string.isRequired,
  /**
    *  Use to specify the user is leaving the current website when clicking this link.
    */
  external: PT.bool,
  /**
    * The size of the link element
    */
  size: PT.oneOf(['inherit', 'base', 'small', 'tiny']),
  /**
    * A React Ref that contains the HTMLAnchorElement this link will render.
    */
  anchorRef: PT.shape({
    current: PT.instanceOf(NodeSafeHTMLElement)
  })
};
Link.defaultProps = {
  external: false,
  size: 'inherit',
  anchorRef: undefined
};
Link.displayName = 'Link';
var Link$1 = /*#__PURE__*/memo(Link);

export { Link$1 as L };
//# sourceMappingURL=Link-CyusQ8lJ.js.map
